<template>
  <div class="location-panel" :style="style">
    <div class="location-panel__icon__wrapper">
      <svg class="location-panel__icon" width="60" height="46" viewBox="0 0 60 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M58.6163 12.2013C59.1195 12.2013 59.4969 12.4528 59.7484 12.8302C60 13.2075 60.1258 13.7107 59.8742 14.088L58.9937 16.8553C58.8679 17.4843 58.3648 17.7358 57.7359 17.7358H54.3396C55.4717 18.4906 56.478 19.3711 57.1069 20.5031C57.8616 21.6352 58.1132 22.8931 58.1132 24.2767V29.9371C58.1132 31.8239 57.4843 33.4591 56.2264 34.8428V42.1384C56.2264 42.8931 55.9748 43.6478 55.3459 44.1509C54.8428 44.6541 54.0881 45.0314 53.3333 45.0314H47.673C46.9182 45.0314 46.1635 44.7799 45.6604 44.1509C45.1572 43.6478 44.7799 42.8931 44.7799 42.1384V37.4843H14.9686V42.1384C14.9686 42.8931 14.717 43.6478 14.0881 44.1509C13.5849 44.6541 12.8302 45.0314 12.0755 45.0314H6.54088C5.78617 45.0314 5.03145 44.7799 4.52831 44.1509C4.02516 43.6478 3.6478 42.8931 3.6478 42.1384V34.8428C2.38994 33.4591 1.76101 31.8239 1.76101 29.9371V24.2767C1.76101 22.8931 2.13837 21.6352 2.7673 20.5031C3.52202 19.3711 4.40252 18.4906 5.53459 17.7358H2.26415C1.50944 17.7358 1.13208 17.4843 1.00629 16.8553L0.12579 14.088C4.13507e-06 13.5849 4.13507e-06 13.2075 0.251576 12.8302C0.503149 12.4528 0.880507 12.2013 1.38365 12.2013H7.79875L8.67925 9.68553C9.81132 6.79245 11.5723 4.40252 14.2138 2.64151C16.8553 0.880503 19.7484 0 22.8931 0H37.2327C40.3774 0 43.2704 0.880503 45.7862 2.64151C48.4277 4.40252 50.1887 6.79245 51.3208 9.68553L52.2013 12.2013H58.6163ZM10.3145 30.9434H10.8176C12.327 30.9434 13.4591 30.8176 14.2138 30.6918C15.3459 30.4403 15.9748 29.9371 15.9748 29.0566C15.9748 28.0503 15.3459 26.7925 13.9623 25.5346C12.5786 24.2767 11.4465 23.522 10.4403 23.522C9.43397 23.522 8.42768 23.8994 7.67296 24.6541C6.91824 25.4088 6.54088 26.2893 6.54088 27.2956C6.54088 28.3019 6.91824 29.1824 7.67296 29.9371C8.42768 30.6918 9.30818 30.9434 10.3145 30.9434ZM15.8491 12.4528L14.0881 16.8553H46.0377L44.2767 12.4528C43.6478 10.9434 42.7673 9.81132 41.5094 8.80503C40.2516 7.79874 38.7421 7.54717 37.2327 7.54717H22.8931C21.3836 7.54717 19.8742 8.05031 18.6164 8.93082C17.3585 9.81132 16.3522 10.9434 15.8491 12.4528ZM49.8113 30.9434C50.8176 30.9434 51.6981 30.566 52.4528 29.8113C53.2075 29.0566 53.5849 28.1761 53.5849 27.1698C53.5849 26.1635 53.2075 25.283 52.4528 24.5283C51.6981 23.7736 50.8176 23.3962 49.8113 23.3962C48.805 23.3962 47.5472 24.0252 46.2893 25.4088C45.0314 26.7925 44.2767 27.9245 44.2767 28.9308C44.2767 29.8113 44.9057 30.3145 46.0377 30.566C46.7924 30.6918 47.9245 30.8176 49.434 30.8176H49.8113V30.9434Z" :fill="providerColor"/>
      </svg>
    </div>
    <div class="location-panel__text">
      <div class="location-panel__text__label">{{ $t('evDeviceLocation') }}</div>
      <div class="location-panel__text__value">{{ evLocationStatus }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocationPanel',
  props: {
    args: {
      type: Object,
      required: true,
    },
    brand: {
      type: Object,
      default: () => ({
        color: '#000000',
      }),
    },
  },
  computed: {
    providerColor() {
      return this.brand.color;
    },
    evLocationStatus() {
      let evLocationStatus = '';

      switch (this.args.evLocationStatus) {
        case 'HOME':
          evLocationStatus = this.$i18n.t('atHome');
          break;
        case 'AWAY':
        default:
          evLocationStatus = this.$i18n.t('outOfHome');
          break;
      }

      return evLocationStatus;
    },
    style() {
      return {
        '--provider-color': this.providerColor,
      };
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/mixins.scss';

.location-panel {
  width: 100%;
  height: 100%;

  padding: 0 8px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  gap: 7px;

  &__icon {
    width: 24px;
    height: 18px;

    &__wrapper {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        height: 24px;
      }
  }

  &__text {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    gap: 3px;

    &__label {
      font-style: normal;
      font-weight: 700;
      font-size: 9px;
      line-height: 10px;
    }

    &__value {
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 32px;
      color: var(--provider-color);
    }
  }

  @include Tablet--Large {
    gap: 24px;

    &__icon {
    width: 60px;
    height: 45px;

      &__wrapper {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        height: 60px;
      }
    }

    &__text {
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;
      gap: 5px;

      &__label {
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 18px;
      }

      &__value {
        font-style: normal;
        font-weight: 400;
        font-size: 32px;
        line-height: 40px;
      }
    }
  }

}
</style>
